import { render, staticRenderFns } from "./DashIntakeAssignment.vue?vue&type=template&id=27873cfc&scoped=true&"
import script from "./DashIntakeAssignment.vue?vue&type=script&lang=js&"
export * from "./DashIntakeAssignment.vue?vue&type=script&lang=js&"
import style0 from "./DashIntakeAssignment.vue?vue&type=style&index=0&id=27873cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27873cfc",
  null
  
)

export default component.exports